export { default } from './useDestinations';
export * from './useDestinations';
